import { ClientsWorkOverviewView } from "@common/types/views/clientsWorkOverviewView";
import { NamedView } from "@common/types/views/views";
import { useUserStatus } from "@hooks/useUserStatus";
import { useMemo } from "react";
import { buildKickWorkViews } from "./kickWorkViews";

/** The Work page's built-in views: the Kick views. */
export function useBuiltInClientsWorkViews(): Array<
    NamedView<ClientsWorkOverviewView>
> {
    const { data: userStatus } = useUserStatus();
    const userId = userStatus?.user.id;
    return useMemo(() => buildKickWorkViews({ userId }), [userId]);
}
